<template>
  <main class="page-sidebar page-padding">
    <profile-form></profile-form>
  </main>
</template>

<script>
  import {mapState, mapMutations, mapActions} from 'vuex'
  import profileForm from '../components/Pages/Profile/profileForm'
  import {setDashboard} from "../mixins/utils/setDashboard";

  export default {
    name: 'profile',
    mixins: [setDashboard],
    components: {
      profileForm
    },
    computed: {
      ...mapState({
        dirt: state => state.profile.dirt
      }),
    },
    methods: {
      ...mapMutations({
        setRoute: 'sidebar/SET_ROUTE_NAME',
        setLink: 'sidebar/SET_LINK_NAME',
        setProfile: 'sidebar/SET_PROFILE'
      }),
      ...mapActions({
        loadUser: 'auth/loadUser'
      }),
    },
    beforeMount() {
      this.setLink('home');
      this.setRoute(this.$t('menu.submenu.profile'));
      this.setProfile(true);
      this.loadUser()
    },
    destroyed() {
      this.setProfile(false);
    },
    beforeRouteLeave(to, from, next) {
      if (this.dirt) {
        const question = window.confirm(this.$t('errors.leaveConfirm'));
        if (question) {
          next();
          this.loadUser()
        } else {
          next(false)
        }
      } else {
        next();
      }
    }
  }
</script>
